export { BonusBadge } from './BonusBadge';
